module.exports = __webpack_public_path__ + "img/logo-ustp.92d2d8c.svg";